<template>
  <Layout>
    <PageHeader :items="items"> </PageHeader>
    <div class="container-app">
      <div class="content-title">
        <span class="title-card-app">Reporte Logs</span>
        <span>
          <router-link
            size="sm"
            class="p-0 ml-2 btn-link-add"
            :to="{ name: 'home' }"
          >
            <b-icon class="icon-plus" icon="arrow90deg-left"></b-icon>
          </router-link>
        </span>
      </div>
      <div class="card-app">
        <b-overlay
          :show="isBusy"
          blur="5px"
          :opacity="1"
          variant="transparent"
          spinner-variant="primary"
          spinner-type="grow"
          rounded="sm"
        >
          <div class="row">
            <div class="col-md-12 m-0 p-0">
              <div class="row">
                <div class="col-md-4">
                  <inputMultiSelect
                    id="schema"
                    ref="schema"
                    name="schema"
                    label="Tipo Consulta"
                    placeholder="Tipo de consulta"
                    :options="listSchemas.filter((x) => x.visible)"
                    :validate="{ required: true }"
                    trackBy="key"
                    :multiple="false"
                    :custom-label="(t) => t.value"
                    :value.sync="schema"
                  />
                </div>
                <div class="col-md-4">
                  <inputMultiSelect
                    v-if="schema"
                    id="model"
                    ref="model"
                    name="model"
                    label="Esquema"
                    placeholder="Modelo de consulta"
                    :options="schema['models']"
                    :validate="{ required: true }"
                    trackBy="key"
                    :multiple="false"
                    :custom-label="(t) => t.value"
                    :value.sync="model"
                  />
                </div>
                <div class="col-md-4" v-if="model && schema">
                  <inputMultiSelect
                    id="type_action"
                    ref="type_action"
                    name="type_action"
                    label="Tipo Acción"
                    placeholder="Tipo de Acción"
                    :options="model['types']"
                    :validate="{ required: false }"
                    trackBy="key"
                    :multiple="false"
                    :custom-label="(t) => t.value"
                    :value.sync="type_action"
                  />
                </div>
                <div class="col-md-4" v-if="schema">
                  <InputText
                    id="author"
                    ref="author"
                    name="author"
                    label="Autor"
                    placeholder="Usuario responsable"
                    :validate="{ required: false }"
                    :value.sync="author"
                  />
                </div>
                <div class="col-md-4" v-if="model && schema">
                  <InputText
                    id="id"
                    ref="data.id"
                    idName="data.id"
                    label="Id Registro"
                    placeholder="Id Registro"
                    :validate="{ required: false }"
                    :value.sync="id"
                  />
                </div>
                <div class="col-md-4" v-if="schema">
                  <label for="date-range">Rango de Fechas</label>
                  <DatePicker
                    timezone="UTC"
                    v-model="date_range"
                    mode="date"
                    :masks="{ input: 'YYYY-MM-DD' }"
                    :columns="2"
                    :popover="{ placement: 'bottom', visibility: 'click' }"
                    is-range
                  >
                    <template v-slot="{ inputValue, inputEvents, isDragging }">
                      <div
                        class="flex flex-col sm:flex-row justify-start items-center"
                      >
                        <b-row>
                          <b-col md="12" class="px-0">
                            <div class="relative flex-grow">
                              <b-input-group>
                                <template v-slot:prepend>
                                  <b-input-group-text class="d-none d-xl-block">
                                    <i class="far fa-calendar" />
                                  </b-input-group-text>
                                </template>
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="AAAA-MM-DD"
                                  :class="
                                    isDragging
                                      ? 'text-gray-600'
                                      : 'text-gray-900'
                                  "
                                  :value="inputValue.start"
                                  v-on="inputEvents.start"
                                  autocomplete="off"
                                />
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="AAAA-MM-DD"
                                  :class="
                                    isDragging
                                      ? 'text-gray-600'
                                      : 'text-gray-900'
                                  "
                                  :value="inputValue.end"
                                  v-on="inputEvents.end"
                                  autocomplete="off"
                                />
                              </b-input-group>
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                    </template>
                  </DatePicker>
                </div>
              </div>
              <div class="row mt-2">
                <b-col>
                  <b-button
                    variant="primary"
                    pill
                    size="md"
                    :disabled="!schema"
                    @click="getLogData()"
                    >Consultar</b-button
                  >
                </b-col>
              </div>

              <div class="row mt-2">
                <BaseDatatable
                  ref="table"
                  :drfprovider="logData"
                  :tableheaders="tableHeaders"
                  :filtermaxrows="-1"
                >
                  <template v-slot:cell(model)="row">{{
                    getModelDisplay(row.value)
                  }}</template>
                  <template v-slot:cell(type)="row">{{
                    getTypeActionDisplay(row.value)
                  }}</template>
                  <template v-slot:cell(created_at)="row">{{
                    $strfDatetime(row.value)
                  }}</template>
                  <template v-slot:cell(data)="row">
                    <vue-json-pretty :data="row.value" :deep="0">
                    </vue-json-pretty>
                  </template>
                </BaseDatatable>
              </div>
            </div>
            <!-- <div>
          Forms: {{ forms_cached.results.length }}<br>
          Dimensions: {{ dimensions_cached.results.length }}<br>
          Sessions: {{ sessions_cached.length }}
      </div> -->
          </div>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { reportsMethods, variablesMethods } from '@state/helpers'
import BaseDatatable from '@components/base-datatable'
import InputMultiSelect from '@components/form/InputMultiSelect'
import getSecret from '@utils/get-secret'
import InputText from '@components/form/InputText'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import { DatePicker } from 'v-calendar'

export default {
  page: {
    title: 'Informe: Logs',
  },
  components: {
    Layout,
    PageHeader,
    InputMultiSelect,
    InputText,
    BaseDatatable,
    VueJsonPretty,
    DatePicker,
  },
  data() {
    return {
      items: [
        {
          text: '/',
          path: '/home',
          to: { name: 'home' },
        },
        {
          text: 'Informe: Logs',
          active: true,
        },
      ],
      listSchemas: [
        {
          key: 'master',
          value: 'Variables y Formularios',
          url: getSecret('SERVER_MASTER_URL'),
          visible: true,
          models: [
            {
              key: 'Variables',
              value: 'Variables',
              types: [
                { key: 'create_variable', value: 'Crear variable' },
                { key: 'update_variable', value: 'Actualizar variable' },
                { key: 'delete_variable', value: 'Eliminar variable' },
              ],
            },
            {
              key: 'FormDimensions',
              value: 'Dimensiones de Formularios',
              types: [
                {
                  key: 'update_form_dimension',
                  value: 'Actualizar/agregar dimensiones',
                },
              ],
            },
            {
              key: 'PollDimensions',
              value: 'Dimensiones de Encuestas',
              types: [
                {
                  key: 'update_poll_dimension',
                  value: 'Actualizar/agregar dimensiones',
                },
              ],
            },
            {
              key: 'FormManagers',
              value: 'Gestores de Formularios',
              types: [
                {
                  key: 'update_form_managers',
                  value: 'Actualizar/asignar gestores',
                },
              ],
            },
            {
              key: 'Forms',
              value: 'Formularios',
              types: [
                { key: 'create_form', value: 'Crear formulario' },
                { key: 'update_form', value: 'Actualizar formulario' },
                { key: 'delete_form', value: 'Eliminar formulario' },
              ],
            },
            {
              key: 'Polls',
              value: 'Encuestas',
              types: [
                { key: 'create_poll', value: 'Crear encuesta' },
                { key: 'update_poll', value: 'Actualizar encuesta' },
                { key: 'delete_poll', value: 'Eliminar encuesta' },
              ],
            },
          ],
        },
        {
          key: 'auth',
          value: 'Usuarios',
          url: getSecret('SERVER_AUTH_URL'),
          visible: this.$store.state.auth.currentSession.user.is_superuser,
          models: [
            {
              key: 'Users',
              value: 'Usuarios',
              types: [
                { key: 'create_user', value: 'Crear usuario' },
                { key: 'update_user', value: 'Actualizar usuario' },
                { key: 'delete_user', value: 'Borrar usuario (inactivar)' },
                {
                  key: 'user_create_ume',
                  value: 'Creación usuario (desde UME)',
                },
                { key: 'append_user_group', value: 'Agregar usuario a grupo' },
                { key: 'set_password', value: 'Definir contraseña' },
              ],
            },
          ],
        },
        {
          key: 'answers',
          value: 'Reportes',
          url: getSecret('SERVER_FORMS_URL'),
          visible: this.$store.state.auth.currentSession.user.is_superuser,
          models: [
            {
              key: 'Reports',
              value: 'Reportes',
              types: [
                { key: 'indexed', value: 'Ciudadano' },
                { key: 'filtered', value: 'Informe Ciudadano (Filtros)' },
              ],
            },
          ],
        },
      ],
      schema: null,
      model: null,
      type_action: null,
      author: null,
      isBusy: false,
      date_range: {},
      id: null,

      tableHeaders: [
        { key: 'model', label: 'Modelo', sortable: true },
        { key: 'type', label: 'Tipo Acción', sortable: true },
        { key: 'created_at', label: 'Fecha', sortable: true },
        { key: 'author', label: 'Autor', sortable: false },
        { key: 'data.id', label: 'Id Registro', sortable: false },

        { key: 'log_action_verbose', label: 'Acción', sortable: true },
        { key: 'origin', label: 'IP', sortable: false },
        { key: 'data', label: 'Datos', sortable: false },
      ],
    }
  },

  mounted() {
    // this.getLogData()
  },
  methods: {
    ...reportsMethods,
    ...variablesMethods,
    getLogData() {
      let _ = this
      let qs = `&schema=${_.schema.key}`
      if (_.model) qs += `&model=${_.model.key}`
      if (_.type_action) qs += `&type=${_.type_action.key}`
      if (_.author) qs += `&author=${_.author}`
      if (_.id) qs += `&id=${_.id}`
      if (Object.keys(_.date_range).length > 0) {
        qs += `&created_at_date__gte=${_.date_range.start
          .toISOString()
          .slice(0, 10)}`
        qs += `&created_at_date__lte=${_.date_range.end
          .toISOString()
          .slice(0, 10)}`
      }
      _.query = qs
      _.isBusy = true
      _.logData()
        .then((response) => {
          _.isBusy = false
          _.$refs.table.refresh()
        })
        .catch((error) => {
          _.isBusy = false
        })
    },

    logData(ctx = null) {
      let _ = this
      if (!_.schema) return () => {}
      let querystring = _.schema.url + '/api/logs/'
      if (ctx) {
        ctx.apiUrl = querystring
        querystring = _.$table_params(ctx)
      } else {
        ctx = {
          apiUrl: querystring,
          currentPage: 1,
        }
        querystring = _.$table_params(ctx)
      }
      const searchParams = new URLSearchParams(querystring);

      const ordering = searchParams.get('ordering');

      const reportUrl = `${querystring}${_.query}${!ordering ? '&ordering=-created_at' : ''}`
      return _.getReportLog(reportUrl)
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          console.log(
            'Se presento un error en la carga de la información',
            error
          )
        })
    },

    getModelDisplay(value) {
      let name = value
      this.listSchemas.forEach((schema) => {
        if (name !== value) return true
        schema.models.forEach((model) => {
          if (model.key === value) {
            name = model.value
            return name
          }
        })
      })
      return name
    },
    getTypeActionDisplay(value) {
      let name = value
      this.listSchemas.forEach((schema) => {
        if (name !== value) return true
        schema.models.forEach((model) => {
          model.types.forEach((type) => {
            if (type.key === value) {
              name = type.value
              return name
            }
          })
        })
      })
      return name
    },
  },

  watch: {
    schema: {
      deep: true,
      handler(newValue, oldValue) {
        this.model = null
        this.type_action = null
      },
    },
    model: {
      deep: true,
      handler(newValue, oldValue) {
        this.type_action = null
      },
    },
  },

  computed: {},
}
</script>
